export const CREATE_POST = 'POST/CREATE';
export const LOAD_POSTS = 'POSTS/LOAD';
export const DELETE_POST = 'POST/DELETE';
export const UPDATE_POST = 'POST/UPDATE';
export const LOADING_STATUS = 'POST/LOADING_STATUS';
